module.exports = __webpack_public_path__ + "static/specialists-slideshow-01-a714d0af72eab4bdb3d299bf4afcb306.jpg";